<template>
  <div class="content">
    <PageHeader title="RCS" :subtitle="$t('template-component.new')" />
    <section class="page-content container-fluid">
      <div class="row">
        <div class="col-lg-8">
          <CardComponent variant="tertiary">
            <FormComponent @submit="saveTemplate">
              <InputComponent v-model="template.name" :label="$tc('app.template_name')" :rules="['max:255']" required></InputComponent>
              <TabsComponent class="mb-3" pills>
                <TabComponent @click="template.type = 'text'" :active="template.type == 'text'">
                  <span class="icon material-symbols-outlined">subject</span>
                  {{ $tc('app.text') }}
                </TabComponent>
                <TabComponent @click="template.type = 'media'" :active="template.type == 'media'">
                  <span class="icon material-symbols-outlined">photo_library</span>
                  {{ $tc('app.file') }}
                </TabComponent>
                <TabComponent @click="template.type = 'card'" :active="template.type == 'card'">
                  <span class="icon material-symbols-outlined">cards</span>
                  {{ $tc('app.rich_card') }}
                </TabComponent>
                <TabComponent @click="template.type = 'carousel'" :active="template.type == 'carousel'">
                  <span class="icon material-symbols-outlined">view_carousel</span>
                  Carrossel
                </TabComponent>
              </TabsComponent>
              <template v-if="template.type == 'text'">
                <p>{{ $tc('rcs.text_description') }}</p>
                <hr />
                <TextAreaComponent v-model="template.body.plain.text" :label="$tc('app.message')" rows="6" maxlength="3072" required>
                  <template #actions>
                    <DropdownComponent variant="tertiary" no-caret>
                      <template #button> + {{ $t('sms.send-msg.sms-input-component.lbl-variables') }} </template>
                      <button class="dropdown-item" @click="addVariable('first_name')">{{ $tc('app.first_name') }}</button>
                      <button class="dropdown-item" @click="addVariable('last_name')">{{ $tc('app.last_name') }}</button>
                      <button class="dropdown-item" @click="addVariable('mobile_number')">{{ $tc('app.mobile_number') }}</button>
                      <button class="dropdown-item" @click="addVariable('email')">Email</button>
                    </DropdownComponent>
                    <Emojis @select="addEmoji" title="Emoji" left="10px" />
                  </template>
                  <small class="form-text text-muted float-right">{{ getStringSizeInBytes(template.body.plain.text) }}/3072</small>
                </TextAreaComponent>
              </template>
              <template v-else-if="template.type == 'media'">
                <p>{{ $tc('rcs.file_description') }}</p>
                <hr />
                <div class="row">
                  <div class="col-5">
                    <RcsMedia v-model="template.body.plain.url" />
                  </div>
                </div>
              </template>
              <template v-else-if="template.type == 'card'">
                <p>{{ $tc('rcs.card_description') }}</p>
                <hr />
                <div class="row">
                  <div class="col-5">
                    <RcsCard v-model="template.body.card" />
                  </div>
                </div>
              </template>
              <template v-else-if="template.type == 'carousel'">
                <p>{{ $tc('rcs.carousel_description') }}</p>
                <hr />
                <div class="row">
                  <div class="col-12">
                    <ButtonComponent v-if="template.body.carousel.cards.length < 10" variant="tertiary" class="float-right mb-3" @click="addCard">
                      <span class="material-symbols-outlined">add_circle</span><span class="span-text">Novo cartão</span>
                    </ButtonComponent>
                  </div>
                </div>
                <div class="row carousel">
                  <div class="col-5" v-for="(card, i) in template.body.carousel.cards" :key="i">
                    <RcsCard v-model="template.body.carousel.cards[i]" />
                    <span v-if="template.body.carousel.cards.length > 2" class="c-pointer material-symbols-outlined remove-card-icon" @click="removeCard(i)"> close </span>
                  </div>
                </div>
              </template>
              <hr />
              <div class="form-group row">
                <label class="col-12">{{ $tc('app.suggested_action', 2) }}</label>
                <small class="col-12 text-muted mb-3">{{ $tc('rcs.suggestion_description') }}</small>
                <div class="col-12">
                  <ButtonComponent @click="addSuggestion" :disabled="template.body.suggestions.length > 10">{{ $tc('rcs.add_suggestion') }}</ButtonComponent>
                </div>
              </div>
              <CardComponent v-for="(suggestion, n) in template.body.suggestions" :key="n">
                <div class="row">
                  <div class="col-md-3">
                    <SelectComponent v-model="template.body.suggestions[n].type" :options="suggestionsType" :label="$tc('app.action_type')" required></SelectComponent>
                  </div>
                  <RcsSuggestion v-model="template.body.suggestions[n]" class="col-md-8"></RcsSuggestion>
                  <div class="col-md-1">
                    <ButtonComponent @click="removeSuggestion(n)" variant="tertiary">
                      <span class="material-symbols-outlined">close</span>
                    </ButtonComponent>
                  </div>
                </div>
              </CardComponent>
              <hr />
              <div class="form-group row">
                <label class="col-12">Adicionar ao(s) grupo(s) de templates</label>
                <small class="col-12 text-muted mb-3">Adicione esse template aos grupo de templates.</small>
                <div class="col-4">
                  <SelectComponent
                    v-model="template.attached_groups"
                    :label="''"
                    :options="group_names"
                    text-field="Domain"
                    multiple
                  />
                </div>
              </div>
              <ButtonComponent type="submit">{{ $tc('app.create') }}</ButtonComponent>
            </FormComponent>
          </CardComponent>
        </div>
        <div class="col">
          <PhonePreview>
            <div v-if="template.type === 'text'" class="row">
              <RcsBubble :value="template.body.plain.text" />
            </div>
            <div v-else-if="template.type === 'media'" class="row">
              <RcsMedia :value="template.body.plain.url" is-preview />
            </div>
            <div class="row carousel" v-else-if="template.type === 'carousel'">
              <RcsCard v-for="(card, i) in template.body.carousel.cards" :key="i" v-model="template.body.carousel.cards[i]" is-preview />
            </div>
            <div v-else-if="template.type === 'card'" class="row">
              <RcsCard :value="template.body.card" is-preview />
            </div>
            <div v-if="template.body.suggestions.length > 0">
              <div class="row carousel">
                <RcsSuggestion v-for="(suggestion, n) in template.body.suggestions" :key="n" :value="suggestion" is-preview />
              </div>
            </div>
          </PhonePreview>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/rebranding/PageHeader.vue';
import RCSService from '@/services/rcs.service';
import axios from '@/plugins/axios';
import moment from 'moment';
import Emojis from '@/components/rebranding/Emojis.vue';
import InputComponent from '@/components/form/InputComponent.vue';
import CardComponent from '@/components/CardComponent.vue';
import PhonePreview from '@/components/PhonePreview.vue';
import RcsBubble from '@/components/rcs/RcsBubble.vue';
import RcsMedia from '@/components/rcs/RcsMedia.vue';
import RcsCard from '@/components/rcs/RcsCard.vue';
import TabsComponent from '@/components/tabs/TabsComponent.vue';
import TabComponent from '@/components/tabs/TabComponent.vue';
import TextAreaComponent from '@/components/form/TextAreaComponent.vue';
import DropdownComponent from '@/components/DropdownComponent.vue';
import ButtonComponent from '@/components/ui/ButtonComponent.vue';
import FormComponent from '@/components/form/FormComponent.vue';
import RcsSuggestion from '@/components/rcs/RcsSuggestion.vue';
import SelectComponent from '@/components/form/SelectComponent.vue';

export default {
  name: 'RCSNewTemplates',
  components: {
    PageHeader,
    Emojis,
    InputComponent,
    CardComponent,
    PhonePreview,
    RcsBubble,
    RcsMedia,
    RcsCard,
    TabsComponent,
    TabComponent,
    TextAreaComponent,
    DropdownComponent,
    ButtonComponent,
    FormComponent,
    RcsSuggestion,
    SelectComponent,
  },
  data() {
    return {
      isSending: false,
      suggestionsType: [
        {
          text: this.$tc('app.reply'),
          value: 'reply',
        },
        {
          text: this.$tc('app.dial_phone'),
          value: 'dial',
        },
        {
          text: this.$tc('app.open_url'),
          value: 'url',
        },
        {
          text: this.$tc('app.show_location'),
          value: 'location',
        },
        {
          text: this.$tc('app.create_calendar_event'),
          value: 'event',
        },
      ],
      groups: [],
      group_names: [],
      template: {
        attached_groups: [],
        type: 'text',
        name: '',
        body: {
          plain: {
            text: '',
            url: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
          },
          card: {
            title: '',
            description: '',
            orientation: 'VERTICAL',
            url: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
            size: 'TALL',
            alignment: 'LEFT',
            buttons: [],
          },
          carousel: {
            cards: [
              {
                title: '',
                description: '',
                image: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
                size: 'TALL',
                buttons: [],
              },
              {
                title: '',
                description: '',
                image: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
                size: 'TALL',
                buttons: [],
              },
            ],
          },
          suggestions: [],
        },
      },
    };
  },
  created() {
    this.fetchTemplateGroups();
    if (this.$route.params.template) {
      this.template = this.$route.params.template;
      if (!this.template.body.suggestions) {
        this.template.body.suggestions = [];
      }
      // if (this.template.type === 'CARD') {
      //   this.template.body.card.buttons.forEach((button) => {
      //     if (button.type === 'dial') {
      //       button.phoneNumber = button.phone_number;
      //     }
      //   });
      // }
    }
  },
  methods: {
    addEmoji(emoji) {
      this.template.body.plain.text = `${this.template.body.plain.text}${emoji}`;
    },
    addVariable(variable) {
      this.template.body.plain.text = `${this.template.body.plain.text}{${variable}}`;
    },
    addCard() {
      this.template.body.carousel.cards.push({
        title: '',
        description: '',
        image: 'https://i.pinimg.com/originals/0c/96/b1/0c96b19dc89ffdaa7ff737cfc04a095f.png',
        size: 'TALL',
        buttons: [],
      });
    },
    removeCard(i) {
      if (this.template.body.carousel.cards.length > 2) {
        this.template.body.carousel.cards.splice(i, 1);
      }
    },
    addSuggestion() {
      this.template.body.suggestions.push({
        type: 'reply',
        text: '',
      });
    },
    removeSuggestion(i) {
      this.template.body.suggestions.splice(i, 1);
    },
    getStringSizeInBytes(str) {
      // Cria um encoder de texto (UTF-8 é o padrão)
      const encoder = new TextEncoder();
      // Codifica a string em bytes (retorna um Uint8Array)
      const bytes = encoder.encode(str);
      // Retorna o tamanho do array de bytes
      return bytes.length;
    },
    saveTemplate() {
      this.isSending = true;
      // terminar aqui
      const template = this.template;
      if (this.template.id) {
        RCSService.updateTemplate(template)
          .then((response) => {
            this.$root.$emit('template.submit');
            console.log('WhatsAppService.createNewTemplate:', response);
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: 'Template atualizado',
              type: 'success',
            });
            this.$router.go(-1);
            this.isSending = false;
          })
          .catch((ex) => {
            this.isSending = false;
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')}`,
              content: 'Erro interno, por favor, tente novamente',
              type: 'danger',
            });
            console.log(ex.response.data.errors);
          })
          .finally(() => {
            this.isSending = false;
          });
      } else {
        RCSService.createNewTemplate(template)
          .then((response) => {
            this.$root.$emit('template.submit');
            this.$toast.show({
              title: this.$t('generic-str.success'),
              content: this.$t('template-component.created'),
              type: 'success',
            });
            this.$router.go(-1);
            this.isSending = false;
          })
          .catch((ex) => {
            console.log(ex.response);
            this.isSending = false;
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')} ${ex.response.status}`,
              content: ex.response.data.message,
              type: 'danger',
            });
            console.log(ex.response.data.errors);
          })
          .finally(() => {
            this.isSending = false;
          });
      }
    },
    fetchTemplateGroups(page) {
      this.fetchedItens = false;
      this.fetched = false;
      this.group_names = [];
      this.template.groups = [];
      RCSService.getTemplateGroups()
        .then(
          (response) => {
            this.fetched = true;
            if (response) {
              this.template.groups = response;
              this.group_names = this.template.groups.map((group) => group.name);
            }
            this.fetchedItens = true;
          },
          (error) => {
            this.content = error;
            this.$toast.show({
              title: `${this.$t('sms.infos.filters.status.lbl-error')}`,
              content: 'Erro interno, por favor, tente novamente',
              type: 'danger',
            });
            this.fetched = true;
          },
        )
        .finally(() => {
          this.fetchedItens = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel {
  flex-wrap: nowrap;
  overflow: auto;
}
.remove-card-icon {
  position: absolute;
  color: #fff;
  right: 25px;
  top: 7px;
}
</style>
